// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAN2KX2CcaUCuKYUMEK849FgGTQHSnFDZQ',
    authDomain: 'new-aunak-eca77.firebaseapp.com',
    databaseURL: 'https://new-aunak-eca77-default-rtdb.firebaseio.com',
    projectId: 'new-aunak-eca77',
    storageBucket: 'new-aunak-eca77.firebasestorage.app',
    messagingSenderId: '394539770907',
    appId: '1:394539770907:web:2e67103ad36589c3c5c4be',
    measurementId: 'G-XKBC38C7T0',
  },
  appSource: 'aunakProApp',
  keys: {
    googleMaps: 'AIzaSyD2ZaiQ_sjRkwE8H_j14ijca3UEjU4Okyw',
  },

  sadad: {
    merchantId: '4816124',
    secretKey: 'amd+L1lLlwxjAIrp', //TlzyDh5wzbBuZsux
    apiUrl: 'https://sandbox.sadad.qa/api/card/pay', // production or sandbox
    successUrl: 'https://new-aunak.web.app/payment-success',
    failUrl: 'https://new-aunak.web.app/payment-fail',
  },

  /**
   * Deployed `aunak-backend` (Node). No trailing slash.
   * Mobile-auth calls `${aunakBackendUrl}/firebase/custom-token`; also used for payments / mf routes.
   * Local: `http://localhost:3001` and set `ALLOWED_ORIGIN` to include the Angular dev origin.
   */
  aunakBackendUrl: 'https://squid-app-4ndr5.ondigitalocean.app',

  /** Optional; leave empty to use `${aunakBackendUrl}/mf` for `InitiateSession` (same as mobile). */
  mfBackendBase: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
